import { get } from "@/request/http";

export const getArticle = id =>
  get("/getVirtualSimulationInfoV2", {
    id: id,
    param: "characteristics"
  });
